export default {
  passwordRegx: "^(?=.*\\d)(?=.*[a-zA-Z]).{8,30}$",
  //必须包含字母和数字的组合，可以使用特殊字符，长度在8-30之间
  validatePassword(password) {
    let regex = new RegExp(this.passwordRegx);
    return regex.test(password);
  },
};
